"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Loader = _interopRequireDefault(require("@insided/shared/uikit/Loader"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var Attachment = function Attachment(_ref) {
  var filename = _ref.filename,
      url = _ref.url,
      key = _ref.key,
      onDelete = _ref.onDelete,
      isAvPending = _ref.isAvPending;

  if (!url) {
    return (0, _preact.h)("li", {
      className: "content-attachments-list__item",
      key: key
    }, (0, _preact.h)("span", {
      className: "content-attachments-list__text--loading"
    }, filename), (0, _preact.h)("span", {
      style: {
        width: '24px',
        position: 'relative'
      }
    }, (0, _preact.h)(_Loader.default, null)));
  }

  return (0, _preact.h)("li", {
    className: "content-attachments-list__item",
    key: key
  }, isAvPending ? (0, _preact.h)("span", {
    className: "content-attachments-list__link"
  }, filename, (0, _preact.h)("span", {
    className: "content-attachments-list__av-status"
  }, ' — ', (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "js.attachments.pending.title"
  }))) : (0, _preact.h)("a", {
    className: "content-attachments-list__link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(url)
  }, filename), (0, _preact.h)(_Close.default, {
    width: 18,
    height: 18,
    className: "content-attachments__delete",
    onClick: onDelete
  }));
};

var _default = Attachment;
exports.default = _default;